// extracted by mini-css-extract-plugin
export default {"menu":"MediaSider_menu__e8kmh","menuItem":"MediaSider_menuItem__wqVW3"};